module.exports = __webpack_public_path__ + "static/media/bigthree-3.0e8d359c.jpg";